<template>
  <div :class="variantStyles.bar_class">
    <div class="flex items-center gap-1.5">
      <Icon name="Info" :class="variantStyles.icon_class" />
      <div :class="variantStyles.text_class">
        {{ text }}
      </div>
    </div>
    <div v-if="$slots.default" class="mt-1">
      <slot />
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { Icon } from "@/components";

const props = defineProps({
  variant: { type: String, default: "info" },
  text: { type: String, required: true },
  size: { type: String, default: "medium" },
  contained: { type: Boolean, default: false },
});

const variantStyles = computed(() => {
  const text_base = "text-lg italic mt-0.5 font-semibold font-inter";
  const bar_base =
    "flex flex-col gap-2 p-4 rounded-xl bg-container-bg border border-container-bg border-l-[3px]";

  const style_map = {
    info: {
      icon_class: "text-info",
      text_class: "text-info",
      bar_class: props.contained ? bar_base + " border-l-info" : "",
    },
    error: {
      icon_class: "text-error",
      text_class: "text-error",
      bar_class: props.contained ? bar_base + " border-l-error" : "",
    },
    success: {
      icon_class: "text-success",
      text_class: "text-success",
      bar_class: props.contained ? bar_base + " border-l-success" : "",
    },
    warning: {
      icon_class: "text-warning",
      text_class: "text-warning",
      bar_class: props.contained ? bar_base + " border-l-warning" : "",
    },
  };
  const size_map = {
    large: {
      icon_class: "min-h-5.5 min-w-5.5 h-5.5 w-5.5",
      text_class: "text-lg",
    },
    medium: {
      icon_class: "min-h-4 min-w-4 h-4 w-4",
      text_class: "text-sm",
    },
    small_medium: {
      icon_class: "min-h-3 min-w-3 h-3 w-3 lg:min-h-4 lg:min-w-4 lg:h-4 lg:w-4",
      text_class: "text-xs lg:text-sm",
    },
    small: {
      icon_class: "min-h-3 min-w-3 h-3 w-3",
      text_class: "text-xs",
    },
  };

  const style = style_map[props.variant] || style_map["info"];
  const size = size_map[props.size] || size_map["medium"];

  return {
    icon_class: style.icon_class + " " + size.icon_class + " shrink-0",
    text_class: text_base + " " + style.text_class + " " + size.text_class,
    bar_class: style.bar_class,
  };
});
</script>
